import React from "react";
import HelpButton from "../HelpContent/HelpButton";
import { FloatingLabel, Form } from "react-bootstrap";
import MyCollapse from "../Common/MyCollapse";

export default function AccountContacts({
  handleAccountChange,
  accountsContact,
  errors,
}) {
  return (
    <div>
      {" "}
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
        <>
          <h5 className=" d-flex align-items-center">
            <span className="ms-2">
              <span className="fw-bold me-2">Billing Contact</span>
              <HelpButton helpKey="settings-billing-settings-billing-contact" />{" "}
              <div className="small text-secondary">
                Contact used for communications related to subscription's
                billing, e.g., invoices
              </div>
            </span>
          </h5>
        </>

        <hr className="my-3 text-secondary" />
        <div className="row">
          <div className="col-6">
            <FloatingLabel label="Name:" className="mb-2">
              <Form.Control
                name="account_name"
                placeholder="Name"
                onChange={handleAccountChange}
                value={accountsContact.account_name}
              />
            </FloatingLabel>
            {errors?.account_name && (
              <div className="alert alert-danger">{errors?.account_name}</div>
            )}
          </div>
          <div className="col-6">
            <FloatingLabel label="Email:" className="mb-2">
              <Form.Control
                placeholder="Email"
                type="email"
                name="account_email"
                onChange={handleAccountChange}
                value={accountsContact.account_email}
              />
            </FloatingLabel>
            {errors?.account_email && (
              <div className="alert alert-danger">{errors?.account_email}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
